export class PromotionCodeDiscountType {
  public static readonly PERCENT = 'percent';
  public static readonly AMOUNT = 'amount';
}

export class InvalidPromotionCodeReason {
  public static readonly INVALID_PAYMENT_METHOD = 'invalid_payment_method';
  public static readonly PAYMENT_ISSUER_NOT_ALLOWED = 'payment_issuer_not_allowed';
  public static readonly QUOTA_EXHAUSTED = 'quota_exhausted';
  public static readonly BUDGET_NOT_ENOUGH = 'budget_not_enough';
  public static readonly USAGE_LIMIT_EXCEEDED = 'usage_limit_exceeded';
  public static readonly CONDITION_NOT_MET = 'condition_not_met';
}



// WEBPACK FOOTER //
// ./src/app/services/promotion-code/enum/promotion-code.enum.ts